import { useCallback } from 'react'

import { Box } from '@material-ui/core'
import { Selectors } from '@scoir/college-search'

import { onAcademicMajorsSearch, onAcademicFocusesKeywordSearch } from './services'

const { API_CALL_NAMES, AcademicFocusSelector, SelectorContextProvider } = Selectors

export type TSelectedValue = {
  [key: string]: string[] | undefined
}

interface IAcademicFocusSelectorProps {
  focusOnly?: boolean
  selectedFoci: string[]
  onSelect: (value: TSelectedValue) => void
}

const AcademicFocus = ({ focusOnly = false, selectedFoci = [], onSelect }: IAcademicFocusSelectorProps) => {
  const handleOnAcademicMajorsSearch = useCallback(
    (value: string) => {
      return onAcademicMajorsSearch(value, focusOnly)
    },
    [focusOnly],
  )

  return (
    <Box
      mb={2}
      pb={3}
      position="relative"
      zIndex={3}
    >
      <SelectorContextProvider
        apiCalls={{
          [API_CALL_NAMES.onAcademicFocusesKeywordSearch]: onAcademicFocusesKeywordSearch,
          [API_CALL_NAMES.onAcademicMajorsSearch]: handleOnAcademicMajorsSearch,
        }}
        data={{ AcademicFocus: selectedFoci }}
        onUpdateData={onSelect}
      >
        <AcademicFocusSelector />
      </SelectorContextProvider>
    </Box>
  )
}

export default AcademicFocus
